import type { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import type { ReactElement } from 'react'
import { Modal, type modalProps } from '~/components/Global/Design/Modal/Modal'
import { CloseTrigger } from '~/components/Global/Interactions/CloseTrigger/CloseTrigger'
import { themeClass } from '~/styles/theme.css'
import {
  buttonGroup,
  content as contentStyle,
  fixedWidthClass,
  headerButtonGroup,
  inner,
  position,
  subtitle as subtitleStyle,
  titleIcon,
  title as titleStyle,
  wrapperTitle
} from './Modal.css'

export type StandardModalProps = modalProps & {
  title?: string | ReactElement
  subtitle?: string | ReactElement
  icon?: IconProp
  headerButtons?: ReactElement[]
  buttons?: ReactElement[]
  fixedWidth?: boolean
}

export const StandardModal = ({
  children,
  onClose,
  title,
  subtitle,
  icon,
  headerButtons,
  buttons,
  fixedWidth,
  ...rest
}: StandardModalProps): ReactElement => {
  return (
    <Modal
      onClose={onClose}
      customPositionClass={clsx(position, fixedWidth && fixedWidthClass)}
      {...rest}
    >
      <div className={clsx(themeClass, inner)}>
        <CloseTrigger onClose={onClose} />
        {title && (
          <div className={titleStyle}>
            {icon && <FontAwesomeIcon icon={icon} className={titleIcon} />}
            <div className={wrapperTitle}>
              {title}
              {subtitle && <div className={subtitleStyle}>{subtitle}</div>}
            </div>
            {headerButtons && (
              <div className={headerButtonGroup}>{headerButtons}</div>
            )}
          </div>
        )}
        <div className={contentStyle}>{children}</div>
        {buttons && <div className={buttonGroup}>{buttons}</div>}
      </div>
    </Modal>
  )
}
